<template>
  <div>
    <b-modal header-bg-variant="primary" header-text-variant="white" v-if="typeof groups.current != 'undefined'" size="lg" id="modal-groups" centered ok-disabled
             title="Поздразделение" cancel-title-html="Закрыть" button-size="sm">

      <div class="row">
        <div class="col-md-12">
          <h5>Основная информация</h5>

          <div class="form-group">
            <b-input size="sm" v-model="groups.current.name" placeholder="Наименование подразделения"></b-input>
            <small class="form-text text-muted">Укажите наименование подразделения организации
            </small>
          </div>

        </div>
      </div>

      <template v-slot:modal-footer="{cancel}">
        <b-button variant="primary" size="sm" @click="regGroups('save')"><span class="mdi mdi-content-save"></span> Сохранить</b-button>
        <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть</b-button>
      </template>

    </b-modal>
    <Register :showorg="true" :params="this.params" :register="this.groups" :links="links" @change="regGroups"></Register>
  </div>
</template>

<script>
import Register from "@/components/base/Register";
// import Enums from "@/components/base/Enums";
import {mapGetters} from "vuex";

export default {
  name: 'Groups',
  components: {
    Register
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (event, id) => {
      event;
      if (id == 'modal-groups') {
        this.regGroups();
      }

    })
  },
  data: function () {
    return {
      links: [
        {name: 'Справочник организаций', link: '/registers/organizations/', icon: 'mdi mdi-domain'},
        {name: 'Справочник сотрудников', link: '/registers/workers/', icon: 'mdi mdi-account-group'},
      ],
      params: {
        name: 'groups',
        title: 'Подразделения',
        icon: 'mdi mdi-home-group',
        table: 'reg_groups',
        order: ' ORDER BY name ASC ',
        addnew: 'Добавить новое подразделение',
        org: true,
        fields: [
          {name: 'ID', model: 'id', type: 'int'},
          {name: 'Наименование', model: 'name', type: 'string', required: true, show: true, print: true},
        ],
        task: ['edit', 'delete', 'select'],
        select: ['name']
      },
      disabled: {

      },
    }
  },
  methods: {
    regGroups: function (mode, id) {
      this.$store.commit('wait', {state: true, name: 'Справочник сотрудников'});
      this.$http
          .post(this.$apiold, {
            task: 'list',
            mode: mode,
            id: id,
            orgid: this.orgs.current.id,
            params: this.params,
            data: this.groups.current
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.$store.commit('user', response.data.user);

            this.$store.commit('regChange', {name: this.params.name, register: response.data.register});

            if (response.data.modal) {
              this.$bvModal.show('modal-groups');
            } else {
              this.$bvModal.hide('modal-groups');
            }


            // Сообщения
            this.$store.commit('alert', response.data.messages);
          });
    },

  },
  created: function () {
    this.regGroups();
  },
  computed: {
    ...mapGetters({
      changed: 'changed',
      orgs: 'orgs',
      groups: 'groups'
    })
  },
  watch: {
    orgs() {
      this.regGroups();
    },
    groups: {
      handler: function () {

      },
      deep: true
    },
    changed() {
      this.regGroups();
    },
  }
}
</script>
